export const CATALOG_SETTINGS_DOC = 'catalogSettings';
export const CUSTOMIZATION = 'customization';

export const DEFAULT_CATALOG_VITRINE_SETTINGS = {
  restrictToUserProductsWeb: false,
  restrictToUserProductsMobile: true,
};
